<template>
  <BreadCrumb PageTitle="Gestion de la black liste" />
  <BlackListe />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import BlackListe from "../../components/Generals/BlackListe.vue";

export default defineComponent({
  name: "BlackListePage",
  components: {
    BreadCrumb,
    BlackListe,
  },
});
</script>